var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgInfo.url),expression:"imgInfo.url"}],staticClass:"banner",style:(_vm.bannerStyle)},[_c('div',{staticClass:"m-banner-list"},[_c('img',{attrs:{"src":_vm.imgInfo.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }